var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 35.869,
    height: 38.268,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(-1252 -2818)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(1252 2818)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(1267 2834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M139.066,182.539a2.453,2.453,0,0,0-1.329.389,2.466,2.466,0,0,0-4.158-1.606,2.465,2.465,0,0,0-3.414-.776V175.92a2.467,2.467,0,0,0-4.934,0v7.548a2.736,2.736,0,0,0-4.522,3.045,8.281,8.281,0,0,1,.485,2.993,14.9,14.9,0,0,0,.839,4.534c1.129,3.085,3.219,4.716,6.044,4.716h5.643a7.141,7.141,0,0,0,5.937-3.279.573.573,0,0,0-.941-.653,6,6,0,0,1-5,2.787h-5.643c-2.327,0-4-1.325-4.959-3.94a13.963,13.963,0,0,1-.779-4.168,9.252,9.252,0,0,0-.629-3.547,1.59,1.59,0,1,1,2.781-1.543,6.9,6.9,0,0,1,.739,1.721v3.36a.573.573,0,0,0,1.145,0V175.922a1.322,1.322,0,0,1,2.644,0v9.9a.573.573,0,0,0,1.145,0v-3.191a1.322,1.322,0,0,1,2.644,0V185.2a.573.573,0,0,0,1.145,0v-2.091a1.322,1.322,0,0,1,2.644,0V186a.573.573,0,0,0,1.145,0v-.989a1.322,1.322,0,0,1,2.644,0v4.37a9.915,9.915,0,0,1-.829,3.929.573.573,0,1,0,1.05.458,11.069,11.069,0,0,0,.924-4.387v-4.37a2.47,2.47,0,0,0-2.467-2.467",
    transform: "translate(-111.368 -160.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M13.1,15.92a.573.573,0,0,0-.573-.573H4.462a3.32,3.32,0,0,1-3.316-3.316V4.462A3.32,3.32,0,0,1,4.462,1.145H7.53A.573.573,0,0,0,7.53,0H4.462A4.467,4.467,0,0,0,0,4.462v7.569a4.467,4.467,0,0,0,4.462,4.462h8.07a.573.573,0,0,0,.573-.573",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M141.168,0H119.2a.573.573,0,0,0,0,1.145h21.969a3.32,3.32,0,0,1,3.316,3.316v7.569a3.32,3.32,0,0,1-3.316,3.316H130.194a.573.573,0,1,0,0,1.145h10.974a4.467,4.467,0,0,0,4.462-4.462V4.462A4.467,4.467,0,0,0,141.168,0",
    transform: "translate(-109.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M87.827,63.81c.358,0,.727-.157.727-.459v-7.27c0-.313-.369-.447-.727-.447s-.727.134-.727.447V59H84.584V56.081c0-.313-.369-.447-.727-.447s-.727.134-.727.447v7.27c0,.3.358.459.727.459s.727-.157.727-.459v-3.21H87.1v3.21c0,.3.358.459.727.459",
    transform: "translate(-76.917 -51.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M178.281,56.91c.291,0,.459-.3.459-.649,0-.3-.145-.626-.459-.626H174.3c-.324,0-.637.157-.637.459v7.259c0,.3.313.459.637.459h3.982c.313,0,.459-.324.459-.626,0-.347-.168-.649-.459-.649h-3.165V60.288h1.7a.506.506,0,0,0,.459-.559c0-.3-.168-.582-.459-.582h-1.7V56.91Z",
    transform: "translate(-160.682 -51.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M253.7,55.634c-.369,0-.727.134-.727.447v7.27c0,.3.313.459.638.459h3.545c.291,0,.436-.324.436-.638s-.145-.638-.436-.638h-2.729V56.081c0-.313-.369-.447-.727-.447",
    transform: "translate(-234.065 -51.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M326.852,63.352V60.757H328.1a2.336,2.336,0,0,0,2.628-2.539v-.067a2.278,2.278,0,0,0-2.539-2.516h-2.248a.493.493,0,0,0-.548.447v7.27c0,.3.358.459.727.459s.727-.157.727-.459m0-6.442H328.1c.727,0,1.174.414,1.174,1.286v.134c0,.872-.447,1.286-1.174,1.286h-1.253Z",
    transform: "translate(-301.077 -51.477)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group1.ab0fcbc45c562fd497790ef7c565a929.svg";
export { ForwardRef as ReactComponent };